export const makeAuthHeader = (token: string): Record<string, string> => ({
	Authorization: `Bearer ${token}`,
});
